export const DEFAULT_ARROW_HEAD_OFFSET = { x: 140, y: 0 };
export const DEFAULT_ARROW_TAIL_OFFSET = { x: -140, y: 0 };
